import { useState } from 'react';
import React from 'react';

import MainHeader from '../../ui-components/MainHeader';
import TopHeaderUi from '../../ui-components/TopHeaderUi';

import PendingTask from './PendingTask';
import ListCreate from './ListCreate';
import CreateListTable from './CreateListTable';
import CreateListItem from './CreateListItem';
import CreateDashboardModal from './CreateDashboardModal';
import AddLinkModal from './AddLinkModal';
import SopModal from './SopModal';
import TaskDashboardView from './TaskDashboardView';
import RequestDetailsListView from './RequestDetailsListView';

const DashboardWrapper = () => {
	const [activeTab, setActiveTab] = useState('Pending Task');
	const uiTabs = [
		'Pending Task',
		'List Create',
		'Create List Table',
		'Create List Item',
		'Create Dashboard Modal',
		'Add Link Modal',
		'Sop Modal',
		'Task Dashboard View',
		'Request Details List View'
	];

	const renderComponents = () => {
		switch (activeTab) {
			case 'Pending Task':
				return <PendingTask />;
			case 'List Create':
				return <ListCreate />;
			case 'Create List Table':
				return <CreateListTable />;
			case 'Create List Item':
				return <CreateListItem />;
			case 'Create Dashboard Modal':
				return <CreateDashboardModal />;
			case 'Add Link Modal':
				return <AddLinkModal />;
			case 'Sop Modal':
				return <SopModal />;
			case 'Task Dashboard View':
				return <TaskDashboardView />;
			case 'Request Details List View':
				return <RequestDetailsListView />;
			default:
				return null;
		}
	};

	return (
		<div className="content">
			<MainHeader />
			<div className="wraper container-fluid dashboard-container bg-gray">
				<TopHeaderUi activeTab={activeTab} setActiveTab={setActiveTab} tabs={uiTabs} />
				{renderComponents()}
			</div>
		</div>
	);
};

export default DashboardWrapper;
